
export const environment = {
  production: true,

  // QA

  // baseUrl: 'https://qanetrapi.icodex.in/',
  // apiUrl: 'http://qanvtcleverviewinputapi.icodex.in',
  // autostyleUrl: 'http://nvtoutsetapi.icodex.in',
  // apiUrlucc: 'https://nvtoutsetapi.icodex.in/support/delete/',
  // apiUrl2: 'https://nvteassistanceservice.icodex.in/support/revised/',
  // apiUrl3: 'https://nvtoutsetapi.icodex.in/support/preediting/revised/',
  // apiUrl4: 'https://nvtoutsetapi.icodex.in/support/download/',
  // apiuccoutput: 'http://nvteassistanceservice.icodex.in/support/output/',
  // apipredelete:'https://nvtoutsetapi.icodex.in/support/delete/',
  // apiKeyPre: 'CUCCLI11UI#AB',
  // KeyUCC: 'CQSmbs3TVopW'

  // Icodex UAT

  // baseUrl: 'https://uattrackingapi.icapp.in/',
  // apiUrl: 'https://uatcleverviewinputapi.icapp.in',
  // autostyleUrl: 'http://uatnvtoutsetapi.icodex.in',
  // apiUrlucc: 'https://uatuccwrapperinputapi.icodex.in/support/delete/',
  // apiUrl2: 'https://uatnvteassistanceservice.icodex.in/support/revised/',
  // apiUrl3: 'http://uatnvtoutsetapi.icodex.in/support/preediting/revised/',
  // apiUrl4: 'http://uatnvtoutsetapi.icodex.in/support/download/',
  // apiuccoutput: 'https://uatuccwrapperinputapi.icodex.in/support/get/uccfinaloutput/',
  // apipredelete:'http://uatnvtoutsetapi.icodex.in/support/delete/',
  // apiKeyPre: 'CUCCLI11UI#AB',
  // KeyUCC: 'CQSmbs3TVopW'

  // NT UAT

  baseUrl: 'https://uatnttrackingapi.icodexsolutions.com/',
  apiUrl: 'http://qanvtcleverviewinputapi.icodex.in',
  autostyleUrl: 'http://nvtoutsetapi.icodex.in',
  apiUrlucc: 'https://uatuccwrapperinputapi.icodexsolutions.com/support/delete/',
  apiUrl2: 'https://ueaiap.novatechset.com/support/revised/',
  apiUrl3: 'https://uosoap.novatechset.com/support/preediting/revised/',
  apiUrl4: 'https://uosoap.novatechset.com/support/download/',
  apiuccoutput: 'https://uosoap.novatechset.com/support/get/uccoutput/',
  apipredelete:'https://uosoap.novatechset.com/support/delete/',
  apiKeyPre: 'CUCCLI11UI#AB',
  KeyUCC: 'CQSmbs3TVopW'

}